const initialState = {
    cookieAceito: false,
    isTODOS: false,
    tipoUsuario: 'galo',
    gnv: '',
    dadosIniciais: {
        nome: '',
        telefone: '',
        email: '',
        unidadeConsumidora: '',
        consumoInicial: '',
        userAcceptedTerms: false
    },
    dadosContrato: {
        numCliente: '',
        numInstalacao: '',
        conexao: 'Monofásico',
        classe: '',
        contaAnexo: '',
        contratoKey: ''
    }, 
    endereco: {
        cep: '',
        cidade: '',
        uf: '',
        bairro: '',
        logradouro: '',
        numero: '',
        complemento: '',
        canHire: null
    },
    historicoConsumo: {
        meses: ['', '', '', '', '', '', '', '', '', '', '', ''],
        media: 0,
        calculoFinal: 0
    },
    dadosResponsavel: {
        nome: '',
        dataNasc: '',
        email: '',
        telefone: '',
        cpf: '',
        rg: '',
        rgOrgao: 'SSP',
        rgOrgaoUf: 'MG',
        profissao: '',
        estadoCivil:  '',
        nacionalidade: 'Brasileira',
        documentoAnexo: '',
        cupom: "GALO",
        economiaPercentual: 20,
        matricula: ''
    },
    enderecoResponsavel: {
        cep: '',
        cidade: '',
        uf: '',
        bairro: '',
        logradouro: '',
        numero: '',
        complemento: ''
    },
    dadosEmpresa: {
        razaoSocial: '',
        cnpj: '',
        tipoSociadade: '',
        email: '',
        tipoRegistro: '',
        nire: '',
        comarca: '',
        numComarca: ''
    }
}

export default function home(state = initialState, action) {
    switch (action.type) {
        case 'UPDATE_INICIAL':
            return {
                ...state,
                dadosIniciais: {
                    ...state.dadosIniciais,
                    nome: action.nome,
                    telefone: action.telefone,
                    email: action.email,
                    unidadeConsumidora: action.unidadeConsumidora,
                    consumoInicial: action.consumoInicial,
                    userAcceptedTerms: action.userAcceptedTerms
                },
                dadosResponsavel: {
                    ...state.dadosResponsavel,
                    nome:  action.unidadeConsumidora === "Residência" ? action.nome : '',
                    email: action.unidadeConsumidora === "Residência" ? action.email : '',
                    telefone: action.telefone,
                }
            };
        case 'UPDATE_GNV':
            return {
                ...state,
                gnv: action.gnv
            };
        case 'UPDATE_DESCONTO':
            return {
                ...state,
                dadosResponsavel: {
                    ...state.dadosResponsavel,
                    economiaPercentual: action.economiaPercentual,
                }
            };
        case 'UPDATE_CONTRATO':
            return {
                ...state,
                dadosContrato: {
                   ...state.dadosContrato,
                    numCliente: action.numCliente,
                    numInstalacao: action.numInstalacao,
                    conexao: action.conexao,
                    classe: action.classe,
                    contaAnexo: action.contaAnexo
                }
            };
        case 'UPDATE_CONTRATO_KEY':
            return {
                ...state,
                dadosContrato: {
                    ...state.dadosContrato,
                    contratoKey: action.contratoKey
                }
            };
        case 'UPDATE_ENDERECO':
            return {
                ...state,
                endereco: {
                    ...state.endereco,
                    cep: action.cep,
                    cidade: action.cidade,
                    uf: action.uf,
                    bairro: action.bairro,
                    logradouro: action.logradouro,
                    numero: action.numero,
                    complemento: action.complemento,
                    canHire: action.canHire
                },
            };
        case 'UPDATE_HISTORICO':
            return {
                ...state,
                historicoConsumo: {
                    ...state.historicoConsumo,
                    meses: action.meses,
                    media: action.media,
                    calculoFinal: action.calculoFinal
                },
                dadosIniciais: {
                    ...state.dadosIniciais,
                    consumoInicial: action.consumoInicial,
                }
            };
        case 'UPDATE_LINK':
            return {
                ...state,
                dadosResponsavel: {
                    ...state.dadosResponsavel,
                    documentoAnexo: action.documentoAnexo
                }
            };
        case 'UPDATE_RESPONSAVEL':
            return {
                ...state,
                dadosResponsavel: {
                    ...state.dadosResponsavel,
                    nome: action.nome,
                    email: action.email,
                    telefone: action.telefone,
                    dataNasc: action.dataNasc,
                    cpf: action.cpf,
                    rg: action.rg,
                    rgOrgao: action.rgOrgao,
                    rgOrgaoUf: action.rgOrgaoUf,
                    profissao: action.profissao,
                    estadoCivil: action.estadoCivil,
                    nacionalidade: action.nacionalidade,
                    documentoAnexo: action.documentoAnexo,
                    cupom: action.cupom,
                    matricula: action.matricula
                }
            };
        case 'UPDATE_RESPONSAVEL_MIN':
            return {
                ...state,
                dadosResponsavel: {
                    ...state.dadosResponsavel,
                    nome: action.nome,
                    profissao: action.profissao,
                    estadoCivil: action.estadoCivil,
                    nacionalidade: action.nacionalidade
                }
            };
        case 'UPDATE_ENDERECO_RESPONSAVEL':
            return {
                ...state,
                enderecoResponsavel: {
                    ...state.enderecoResponsavel,
                    cep: action.cep,
                    cidade: action.cidade,
                    uf: action.uf,
                    bairro: action.bairro,
                    logradouro: action.logradouro,                    
                    numero: action.numero,
                    complemento: action.complemento,
                },
            };
        case 'UPDATE_EMPRESA':
            return {
                ...state,
                dadosEmpresa: {
                    ...state.dadosEmpresa,
                    razaoSocial: action.razaoSocial,
                    cnpj: action.cnpj,
                    tipoSociadade: action.tipoSociadade,
                    email: action.email,
                    tipoRegistro: action.tipoRegistro,
                    nire: action.nire,
                    comarca: action.comarca,
                    numComarca: action.numComarca
                }
            };
        case 'UPDATE_COOKIE':
            return {
                ...state,
                cookieAceito: action.cookieAceito
            };
        case 'CLEAR_USER':
            return {
                ...state,
                isTODOS: false,
                tipoUsuario: 'galo',
                gnv: '',
                dadosIniciais: initialState.dadosIniciais,
                dadosContrato: initialState.dadosContrato,
                endereco: initialState.endereco,
                historicoConsumo: initialState.historicoConsumo,
                dadosResponsavel: initialState.dadosResponsavel,
                enderecoResponsavel: initialState.enderecoResponsavel,
                dadosEmpresa: initialState.dadosEmpresa
            };
         case 'CLEAR':
            state = initialState;
            return state;
        default:
            return state
    }
};
